import React, { useState, useEffect } from 'react';
import { CaptureOverlay } from '../shared';

interface GuidedCountdownProps {
  taskName: string;
  onComplete: () => void;
  onClose: () => void;
}

export const GuidedCountdown: React.FC<GuidedCountdownProps> = ({
  taskName,
  onComplete,
  onClose,
}) => {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count <= 0) {
      onComplete();
      return;
    }
    const timer = setTimeout(() => setCount(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [count, onComplete]);

  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className="gc-countdown-body">
        <div className="gc-countdown-label">Launching in</div>
        <div className="gc-countdown-num">{count}</div>
        <div className="gc-countdown-desc">
          We'll deep-link you to the app. Start your screen recording from Control Center as soon as it opens.
        </div>
        <div className="gc-dots-row">
          {[3, 2, 1].map(n => (
            <div
              key={n}
              className={count >= n ? 'gc-dot-active' : 'gc-dot-inactive'}
            />
          ))}
        </div>
      </div>
    </CaptureOverlay>
  );
};
